import { Routes } from '@angular/router';
import { CallbackComponent } from '@app/callback/callback.component';
import { ElementsInfo } from '@app/core/shared/models/element';
import { AuthenticatedElementGuard } from '@shared/guards/authenticated-element.guard';
import { ElementNavigationPermissionGuard } from '@shared/guards/element-navigation-permissions.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'elements', pathMatch: 'full' },
  {
    path: 'elements',
    canActivate: [AuthenticatedElementGuard],
    loadComponent: () =>
      import('./core/landing-page/landing-page.component').then(c => c.LandingPageComponent),
    title: 'Home'
  },
  {
    path: 'notifications',
    data: { breadcrumb: 'Notifications' },
    canActivate: [AuthenticatedElementGuard],
    title: 'Notifications',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@core/notifications/notifications-page/notifications-page.component').then(
            c => c.NotificationsPageComponent
          )
      },
      {
        path: 'summary',
        data: { breadcrumb: 'Notification Summary' },
        loadComponent: () =>
          import('@core/notifications/notification-summary/notification-summary.component').then(
            m => m.NotificationSummaryComponent
          )
      }
    ]
  },
  {
    path: ElementsInfo.SURF.url,
    data: { breadcrumb: ElementsInfo.SURF.name.toUpperCase() },
    canActivate: [AuthenticatedElementGuard],
    canActivateChild: [ElementNavigationPermissionGuard],
    loadChildren: () => import('./surf/surf.module').then(m => m.SurfModule),
    title: ElementsInfo.SURF.name.toUpperCase()
  },
  {
    path: ElementsInfo.PIPELINES.url,
    data: { breadcrumb: ElementsInfo.PIPELINES.name.toUpperCase() },
    canActivate: [AuthenticatedElementGuard],
    canActivateChild: [ElementNavigationPermissionGuard],
    loadChildren: () => import('./pipelines/pipelines.module').then(m => m.PipelinesModule),
    title: ElementsInfo.PIPELINES.name.toUpperCase()
  },
  {
    path: 'componentTree',
    data: { breadcrumb: 'Hierarchy Tree' },
    canActivate: [AuthenticatedElementGuard],
    loadChildren: () =>
      import('./core/installation-content/installation-content.module').then(
        m => m.InstallationContentModule
      ),
    title: 'Hierarchy Tree'
  },
  { path: 'callback', component: CallbackComponent },
  {
    path: 'error',
    loadComponent: () =>
      import('./core/shared/errors/error-pages/error-page.component').then(m => m.ErrorPageComponent),
    title: 'Error'
  },
  {
    path: '404',
    canActivate: [AuthenticatedElementGuard],
    loadComponent: () =>
      import('./core/shared/errors/not-found/not-found.component').then(c => c.NotFoundComponent),
    title: 'Not Found'
  },
  { path: '**', redirectTo: 'callback' }
];
